import { render, staticRenderFns } from "./BPMNUserTask.vue?vue&type=template&id=55b3a8ab&"
import script from "./BPMNUserTask.vue?vue&type=script&lang=js&"
export * from "./BPMNUserTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports